var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _path11, _path12, _path13, _path14, _circle5, _circle6, _circle7, _circle8, _path15, _path16, _path17, _path18, _circle9, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBannerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 246,
    viewBox: "0 0 316 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.098 175.641H252.309C253.193 175.641 254.061 175.393 254.812 174.925C258.858 172.408 257.074 166.165 252.309 166.165H215.327C205.235 166.165 197.054 158.008 197.054 147.946C197.054 144.784 197.861 141.811 199.282 139.22C189.569 139.646 181.825 147.632 181.825 157.421C181.825 167.484 190.006 175.641 200.098 175.641Z",
    fill: "#373AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.812 174.925L254.483 174.397V174.397L254.812 174.925ZM252.309 176.263H200.098V175.019H252.309V176.263ZM181.203 157.421C181.203 147.296 189.212 139.039 199.255 138.599L199.309 139.841C189.925 140.252 182.447 147.968 182.447 157.421H181.203ZM199.255 138.599C199.534 138.586 199.816 138.58 200.098 138.58V139.824C199.834 139.824 199.571 139.83 199.309 139.841L199.255 138.599ZM200.098 176.263C189.665 176.263 181.203 167.829 181.203 157.421H182.447C182.447 167.138 190.348 175.019 200.098 175.019V176.263ZM252.309 166.787H215.327V165.543H252.309V166.787ZM196.432 147.946C196.432 144.677 197.267 141.601 198.737 138.921L199.827 139.519C198.456 142.021 197.676 144.891 197.676 147.946H196.432ZM198.737 138.921C201.943 133.072 208.17 129.104 215.327 129.104V130.348C208.641 130.348 202.823 134.054 199.827 139.519L198.737 138.921ZM215.327 166.787C204.893 166.787 196.432 158.353 196.432 147.946H197.676C197.676 157.663 205.577 165.543 215.327 165.543V166.787ZM252.309 165.543C257.699 165.543 259.717 172.606 255.14 175.453L254.483 174.397C257.998 172.21 256.448 166.787 252.309 166.787V165.543ZM252.309 175.019C253.077 175.019 253.831 174.804 254.483 174.397L255.14 175.453C254.29 175.982 253.31 176.263 252.309 176.263V175.019Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.81 184.086H266.964L271.259 157.244H245.105L240.81 184.086Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.2438
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.987 187.465H263.281L267.377 160.623H248.283L243.987 187.465Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.2438
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M254.315 181.367H278.766L279.526 176.681H255.075L254.315 181.367Z",
    fill: "#373AF5",
    stroke: "#1B1B1B",
    strokeWidth: 1.2438
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.932 171.408H280.383L281.142 166.722H256.691L255.932 171.408Z",
    fill: "#373AF5",
    stroke: "#1B1B1B",
    strokeWidth: 1.2438
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3297 39.6406H46.3219C45.5083 39.6406 44.711 39.8684 44.0203 40.2982C40.3001 42.613 41.9404 48.3537 46.3219 48.3537H80.3269C89.6064 48.3537 97.129 55.8541 97.129 65.1064C97.129 68.0132 96.3865 70.7471 95.0803 73.1298C104.012 72.7383 111.132 65.3949 111.132 56.3934C111.132 47.1411 103.609 39.6406 94.3297 39.6406Z",
    fill: "#373AF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0203 40.2982L43.5856 39.5997L43.5856 39.5997L44.0203 40.2982ZM46.3219 38.8179H94.3297V40.4633H46.3219V38.8179ZM111.955 56.3934C111.955 65.8393 104.483 73.5411 95.1164 73.9516L95.0443 72.3079C103.54 71.9355 110.309 64.9505 110.309 56.3934H111.955ZM95.1163 73.9516C94.8555 73.9631 94.5933 73.9688 94.3297 73.9688V72.3235C94.5692 72.3235 94.8075 72.3182 95.0443 72.3079L95.1163 73.9516ZM94.3297 38.8179C104.061 38.8179 111.955 46.6845 111.955 56.3934H110.309C110.309 47.5977 103.157 40.4633 94.3297 40.4633V38.8179ZM46.3219 47.531H80.3269V49.1764H46.3219V47.531ZM97.9517 65.1064C97.9517 68.155 97.1726 71.0244 95.8017 73.5252L94.3589 72.7343C95.6004 70.4697 96.3063 67.8714 96.3063 65.1064H97.9517ZM95.8017 73.5252C92.8113 78.9803 87.0026 82.6819 80.3269 82.6819V81.0365C86.3796 81.0365 91.6465 77.6822 94.3589 72.7343L95.8017 73.5252ZM80.3269 47.531C90.0585 47.531 97.9517 55.3975 97.9517 65.1064H96.3063C96.3063 56.3108 89.1544 49.1764 80.3269 49.1764V47.531ZM46.3219 49.1764C41.113 49.1764 39.163 42.3516 43.5856 39.5997L44.4549 40.9967C41.4373 42.8744 42.7678 47.531 46.3219 47.531V49.1764ZM46.3219 40.4633C45.6619 40.4633 45.0152 40.6481 44.4549 40.9967L43.5856 39.5997C44.4068 39.0888 45.3547 38.8179 46.3219 38.8179V40.4633Z",
    fill: "#1B1B1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7412 29.9375H63.6346L68.2158 58.5645H40.3224L35.7412 29.9375Z",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.64536
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4443 33.6875H48.7335L51.9789 54.9582H36.8483L33.4443 33.6875Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.64536
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.735,
    cy: 115.91,
    r: 84.4604,
    transform: "rotate(12.0727 152.735 115.91)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M195.992 124.614C191.112 147.432 181.774 166.983 170.674 180.154C159.541 193.363 146.84 199.944 135.175 197.449C123.51 194.954 114.612 183.754 109.856 167.146C105.115 150.587 104.592 128.926 109.472 106.109C114.352 83.2918 123.69 63.7402 134.79 50.5697C145.923 37.3599 158.625 30.7797 170.289 33.2746C181.954 35.7695 190.852 46.9695 195.608 63.5777C200.349 80.1364 200.872 101.797 195.992 124.614Z",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7471 97.8262L234.886 132.933",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M170.369 33.3105L135.263 197.449",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M223.777 70.769L224.339 71.6582L223.777 70.769ZM106.373 45.6582L107.249 45.0766L106.373 45.6582ZM223.215 69.8798C184.243 94.5036 132.739 83.4878 107.249 45.0766L105.497 46.2398C131.619 85.6037 184.4 96.8928 224.339 71.6582L223.215 69.8798Z",
    fill: "#1B1B1B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.735,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(-167.927 152.735 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.361,
    r: 83.9437,
    transform: "rotate(12.0727 152.734 115.361)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.992 124.614C191.112 147.432 181.774 166.983 170.674 180.154C159.541 193.363 146.84 199.944 135.175 197.449C123.51 194.954 114.612 183.754 109.856 167.146C105.115 150.587 104.592 128.926 109.472 106.109C114.352 83.2918 123.69 63.7402 134.79 50.5697C145.923 37.3599 158.625 30.7797 170.289 33.2746C181.954 35.7695 190.852 46.9695 195.608 63.5777C200.349 80.1364 200.872 101.797 195.992 124.614Z",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7471 97.8281L234.886 132.935",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.37 33.3125L135.264 197.451",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M223.779 70.771L224.341 71.6602L223.779 70.771ZM106.375 45.6602L107.251 45.0786L106.375 45.6602ZM223.217 69.8818C184.245 94.5056 132.741 83.4897 107.251 45.0786L105.499 46.2417C131.621 85.6056 184.402 96.8948 224.341 71.6602L223.217 69.8818Z",
    fill: "#1B1B1B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.734,
    cy: 115.363,
    r: 83.9437,
    transform: "rotate(-167.927 152.734 115.363)",
    stroke: "#1B1B1B",
    strokeWidth: 2.10363
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6897 159.956L81.1278 159.066L81.6897 159.956ZM199.094 185.066L198.217 185.648L199.094 185.066ZM82.2515 160.845C121.223 136.221 172.728 147.237 198.217 185.648L199.97 184.485C173.848 145.121 121.066 133.832 81.1278 159.066L82.2515 160.845Z",
    fill: "#1B1B1B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.547 234.276C131.784 235.866 130.552 237.295 128.945 237.295L85.5462 237.295L83.0791 218.709L52.4386 220.586C49.5641 220.762 49.0218 224.765 51.7458 225.7L85.5462 237.295L83.0791 218.709L81.9805 208.739C81.8089 207.182 83.0283 205.82 84.5951 205.82L125.034 205.82C126.337 205.82 127.444 206.774 127.636 208.063L131.547 234.276Z",
    fill: "#373AF5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5462 237.295L51.7458 225.7C49.0218 224.765 49.5641 220.762 52.4386 220.586L83.0791 218.709M85.5462 237.295L83.0791 218.709M85.5462 237.295L128.945 237.295C130.552 237.295 131.784 235.866 131.547 234.276L127.636 208.063C127.444 206.774 126.337 205.82 125.034 205.82L84.5951 205.82C83.0283 205.82 81.8089 207.182 81.9805 208.739L83.0791 218.709",
    stroke: "#1B1B1B",
    strokeWidth: 1.57828
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93795 100.766C1.39851 97.1123 4.22994 93.8321 7.92315 93.8321H174.841C177.841 93.8321 180.388 96.0306 180.826 98.9985L196.009 201.838C196.549 205.491 193.718 208.772 190.024 208.772H23.1069C20.1069 208.772 17.5599 206.573 17.1217 203.605L1.93795 100.766Z",
    fill: "#373AF5",
    stroke: "#1B1B1B",
    strokeWidth: 1.57828
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4423 108.215C15.992 105.195 18.3318 102.481 21.3856 102.481L184.626 102.481C187.109 102.481 189.216 104.303 189.572 106.761L202.29 194.408C202.728 197.423 200.39 200.124 197.344 200.124H34.4518C31.9762 200.124 29.8736 198.312 29.5085 195.863L16.4423 108.215Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.57828
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.85 169.032L110.85 169.032L110.846 169.029C103.397 162.966 98.7031 158.898 95.8672 155.492C93.056 152.116 92.0961 149.421 92.0961 146.086C92.0961 140.576 96.5013 136.17 102.011 136.17C106.53 136.17 109.064 138.688 110.891 140.744L111.242 141.138L111.593 140.744C113.419 138.688 115.954 136.17 120.472 136.17C125.982 136.17 130.388 140.576 130.388 146.086C130.388 149.421 129.428 152.116 126.617 155.492C123.781 158.898 119.087 162.966 111.638 169.029L111.638 169.029L111.634 169.032L111.242 169.359L110.85 169.032Z",
    fill: "#373AF5",
    stroke: "#1B1B1B",
    strokeWidth: 0.938285
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0795 201.563L81.2565 174.737C76.1011 168.211 73.0373 159.95 73.1206 150.984C73.3135 130.204 90.2848 113.453 110.949 113.645C131.614 113.836 148.271 130.9 148.078 151.68C147.885 172.46 130.914 189.211 110.249 189.019C101.333 188.937 93.1765 185.703 86.7828 180.398L59.6058 207.224C58.8293 207.99 57.8158 208.37 56.8057 208.36C55.7957 208.351 54.7894 207.953 54.0273 207.172C52.4992 205.607 52.5225 203.099 54.0795 201.563ZM110.323 181.085C126.64 181.237 140.035 168.015 140.188 151.607C140.34 135.199 127.193 121.73 110.876 121.579C94.5584 121.427 81.1631 134.649 81.0107 151.057C80.8584 167.465 94.006 180.934 110.323 181.085Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 1.29164
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.1439,
    y: 190.154,
    width: 13.9568,
    height: 33.3389,
    rx: 6.97839,
    transform: "rotate(45.532 61.1439 190.154)",
    fill: "#1B1B1B",
    stroke: "#1B1B1B",
    strokeWidth: 1.29164
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBannerIcon);
export default __webpack_public_path__ + "static/media/loginBannerIcon.39f33c607fa7b370decf68e119849118.svg";
export { ForwardRef as ReactComponent };